<template>
  <div>
    <div class="bg-gradient"></div>
    <div class="main-page">
      <div class="container-fluid">
        <div class="row">
          <div class="d-flex today-call" v-if="Object.keys($route.query).length==0">
            <div class="">
              <span class="count-title d-block mb-fix">Today’s Calls</span>
              <router-link
                class="count d-block"
                :class="GetEnquiriesCount === 0 ? 'disabled' : ''"
                :to="{ name: 'Today', params: { page:'enquiries_builders', callType: 'todays_calls' } }"
                >{{ GetEnquiriesCount }}</router-link
              >
            </div>
            <div class="">
              <span class="count-title d-block mb-fix">Backlog</span>
              <router-link
                class="count d-block"
                :class="backLogData === 0 ? 'disabled' : ''"
                :to="{ name: 'Today', params: { page:'enquiries_builders', callType: 'backlog_calls' } }"
                >{{ backLogData }}</router-link
              >
            </div>
          </div>
          <div
            v-if="$route.query.is_advanced_search"
            class="col-6 text-right"
            style="margin-top: -15px"
          >
            <div class="text-center d-table ml-auto">
              <div @click="saveSearchModal = true" style="cursor: pointer">
                <img
                  src="@/assets/saveSVG.svg"
                  alt=""
                  width="24"
                  class="mb-fix"
                />
                <span
                  class="count-title d-block"
                  style="line-height: 1; font-size: 8px"
                  >Saved<br />Searches</span
                >
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="search-holder mt-30 search-holder-list">
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Search by name, enquiryno, email, phone or enquiry"
                  @input="(e) => (Filter = e.target.value)"
                  :value="Filter"
                  class="search form-control"
                  @keyup.enter="FilterData"
                />
                <svg
                  v-if="Filter"
                  @click="resetFilter"
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512.001 512.001"
                  style="enable-background: new 0 0 512.001 512.001"
                  xml:space="preserve"
                  width="14"
                  height="14"
                  class="close"
                >
                  <g>
                    <g>
                      <path
                        d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                            L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                            c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                            l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                            L284.286,256.002z"
                      />
                    </g>
                  </g>
                </svg>
                <div class="input-group-append align-fix" id="button-addon4">
                  <button
                    class="btn btn-white rounded-right"
                    :disabled="!Filter"
                    @click="FilterData"
                    type="button"
                  >
                    <svg
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 451 451"
                      style="enable-background: new 0 0 451 451"
                      xml:space="preserve"
                    >
                      <g>
                        <path
                          d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                                        s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                                        C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                                        s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z"
                        />
                      </g>
                    </svg>
                  </button>
                  <button
                    v-b-toggle.sidebar-right
                    class="filter-menu btn btn-filter btn-white"
                    type="button"
                  >
                    <img src="@/assets/filter.svg" alt="" />
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <span class="result-Text"
                  >{{ pageStart }} - {{ pageEnd }} of {{ total }}</span
                >
              </div>
              <NCD searchKey="ncd" label="NCD" />
            </div>
          </div>
          <!-- Enquiry Card -->
          <div class="col-12">
            <div class="card enquiry-card m-height">
              <b-list-group class="list-group-flush">
                <b-list-group-item
                  :to="{ name: 'Details', params: { id: item.id } }"
                  v-for="item in GetEnquiriesList"
                  :key="item.id"
                >
                  <div class="row">
                    <div class="col-6 pr-1">
                      <span class="name ellipses" v-if="item.full_name">{{
                        item.full_name
                      }}</span>
                      <span class="project-name" v-if="item.enquiry">{{
                        item.enquiry
                      }}</span>
                      <span
                        class="project-name d-block mt-1"
                        v-if="item.broker_name"
                        >{{ item.broker_name }}</span
                      >
                    </div>
                    <div class="col-6 pl-1 text-right">
                      <span class="label label-tag" v-if="item.status">{{
                        item.status
                      }}</span>
                      <div class="d-block" v-if="item.ncd">
                        <img
                          src="@/assets/date.svg"
                          alt=""
                          class="date-icon mr-1"
                        />
                        <span class="project-name">{{ item.ncd }}</span>
                      </div>
                      <div class="d-block" v-if="item.assigned_to">
                        <img
                          src="@/assets/UserIcon.svg"
                          alt=""
                          class="date-icon mr-1"
                        />
                        <span class="project-name ellipses-author">{{
                          item.assigned_to
                        }}</span>
                      </div>
                    </div>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </div>
          </div>
          <!-- Right Menu Sidebar -->
          <b-sidebar
            id="sidebar-right"
            ref="sidebar-right"
            title="Advance Search"
            bg-variant="white"
            backdrop
            right
            shadow
          >
            <template v-slot="{ hide }">
              <div class="card form-card sidebar-form-card">
                <b-form
                  @submit.prevent="AdvancedFilter"
                  @reset="resetAdvancedFilter"
                >
                  <b-form-group>
                    <label>Saved Search</label>
                    <b-form-select
                      v-model="AdvancedFilterBroker.save_search_id"
                      :options="saved_search_list"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-group>
                    <b-form-input
                      type="text"
                      v-model="AdvancedFilterBroker.name"
                      placeholder="Name"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group>
                    <b-form-input
                      type="text"
                      v-model="AdvancedFilterBroker.phone"
                      placeholder="Mobile Number"
                      minlength="10"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group>
                    <b-form-input
                      type="email"
                      v-model="AdvancedFilterBroker.email"
                      placeholder="Email Address"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group>
                    <b-form-textarea
                      placeholder="Comment"
                      v-model="AdvancedFilterBroker.comment"
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                  <b-form-group>
                    <b-form-input
                      type="text"
                      v-model="AdvancedFilterBroker.enquiry_no"
                      placeholder="Enquiry Number"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group>
                    <!-- <b-form-select v-model="AdvancedFilterBroker.building_id" :options="ProjectsList"></b-form-select> -->
                    <multiselect
                      v-model="AdvancedFilterBroker.building_id"
                      :searchable="false"
                      placeholder="Select Projects"
                      label="text"
                      track-by="value"
                      :options="ProjectsList"
                      :multiple="true"
                      :taggable="true"
                    ></multiselect>
                  </b-form-group>
                  <b-form-group>
                    <b-form-select
                      v-model="AdvancedFilterBroker.enquiry_source_id"
                      :options="LeadSourcesList"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-group>
                    <multiselect
                      v-model="enquiry_statuses"
                      :searchable="false"
                      placeholder="Status"
                      label="text"
                      track-by="value"
                      :options="EnquirystatusesList"
                      :multiple="true"
                      :taggable="true"
                    ></multiselect>
                  </b-form-group>
                  <b-form-group>
                    <multiselect
                      v-model="broker_ids"
                      :searchable="false"
                      placeholder="Brokers"
                      label="text"
                      track-by="value"
                      :options="brokersList"
                      :multiple="true"
                      :taggable="true"
                    ></multiselect>
                  </b-form-group>
                  <b-form-group>
                    <multiselect
                      v-model="assigned_to"
                      :searchable="false"
                      placeholder="Assigned To"
                      label="text"
                      track-by="value"
                      :options="AssignedTo"
                      :multiple="true"
                      :taggable="true"
                    ></multiselect>
                  </b-form-group>
                  <b-form-group>
                    <b-form-select
                      v-model="AdvancedFilterBroker.visited"
                      :options="Allvisited"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-group>
                    <b-form-select
                      v-model="AdvancedFilterBroker.is_nri"
                      :options="NriList"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-group>
                    <multiselect
                      v-model="dead_reason_seq_ids"
                      :searchable="false"
                      placeholder="Select Reasons"
                      label="text"
                      track-by="value"
                      :options="DeadReasonList"
                      :multiple="true"
                      :taggable="true"
                    ></multiselect>
                    <!-- <b-form-select v-model="AdvancedFilterBroker.dead_reason_seq_ids" :options="DeadReasonList"></b-form-select> -->
                  </b-form-group>
                  <b-form-group label="Next Call Date">
                    <div class="row">
                      <div class="col-6 pr-1">
                        <datetime
                          type="date"
                          v-model="AdvancedFilterBroker.next_call_date_from"
                          placeholder="Start Date"
                        ></datetime>
                      </div>
                      <div class="col-6 pl-1">
                        <datetime
                          type="date"
                          v-model="AdvancedFilterBroker.next_call_date_upto"
                          placeholder="End Date"
                        ></datetime>
                      </div>
                    </div>
                  </b-form-group>
                  <b-form-group label="Visit Date">
                    <div class="row">
                      <div class="col-6 pr-1">
                        <datetime
                          type="date"
                          v-model="AdvancedFilterBroker.visit_date_from"
                          placeholder="Start Date"
                        ></datetime>
                      </div>
                      <div class="col-6 pl-1">
                        <datetime
                          type="date"
                          v-model="AdvancedFilterBroker.visit_date_upto"
                          placeholder="End Date"
                        ></datetime>
                      </div>
                    </div>
                  </b-form-group>
                  <b-form-group label="Created Date">
                    <div class="row">
                      <div class="col-6 pr-1">
                        <datetime
                          type="date"
                          v-model="AdvancedFilterBroker.created_at_from"
                          placeholder="Start Date"
                        ></datetime>
                      </div>
                      <div class="col-6 pl-1">
                        <datetime
                          type="date"
                          v-model="AdvancedFilterBroker.created_at_upto"
                          placeholder="End Date"
                        ></datetime>
                      </div>
                    </div>
                  </b-form-group>
                  <b-form-group>
                    <b-form-checkbox
                      v-model="AdvancedFilterBroker.remove_recycled_enq"
                      value="true"
                      unchecked-value="false"
                      ><span class="name mt-1" style="font-size: 13px"
                        >Remove Recycled ENQ</span
                      >
                    </b-form-checkbox>
                  </b-form-group>
                  <b-form-group class="btn-fixed">
                    <b-button
                      variant="primary"
                      type="submit"
                      block
                      @click="hide"
                      >Search</b-button
                    >
                    <b-button variant="primary-outline" block type="reset"
                      >Reset</b-button
                    >
                  </b-form-group>
                </b-form>
              </div>
            </template>
          </b-sidebar>
          <!-- modal -->
          <b-modal
            hide-footer
            title="Save Search History"
            v-model="saveSearchModal"
            @hidden="search_name = null"
          >
            <div class="bg-white animate__animated animate__slideInRight">
              <div class="row">
                <div class="col-12">
                  <div class="card details-card form-card">
                    <div class="card-body p-0 mt-0">
                      <div class="row">
                        <div class="col-12">
                          <b-form @submit.prevent="saveSearch()">
                            <b-form-group>
                              <label
                                >Name<span class="text-danger">*</span></label
                              >
                              <b-form-input
                                type="text"
                                v-model="search_name"
                                required
                                placeholder="Name"
                              ></b-form-input>
                            </b-form-group>
                            <b-form-group class="mt-3">
                              <b-button type="submit" variant="primary" block
                                >Save</b-button
                              >
                            </b-form-group>
                          </b-form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
        <paginate
          v-if="totalPages > 1"
          v-model="pageNo"
          :page-count="totalPages"
          :click-handler="goToPage"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :prev-class="'page-item'"
          :prev-link-class="'page-link'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
          :container-class="'pagination justify-content-center'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
        >
        </paginate>
        <router-link
          to="/Enquiry"
          class="float-btn"
          v-if="$store.state.can_create"
          ><img src="@/assets/plus.svg" alt=""
        /></router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import { Datetime } from "vue-datetime";
import qs from "qs";
import NCD from "@/components/Common/Ncd.vue";
import {
  paramsFromQuery,
  prepareEnquiriesSearchParams,
} from "@/assets/scripts/utility.js";
export default {
  components: {
    datetime: Datetime,
    Multiselect,
    NCD,
  },
  data() {
    return {
      saved_search_list: [],
      search_name: null,
      saveSearchModal: false,
      dead_reason_seq_ids: [],
      assigned_to: [],
      broker_ids: [],
      enquiry_statuses: [],
      advSearchParams: [],
      GetEnquiriesList: [],
      GetEnquiriesCount: 0,
      backLogData: 0,
      total: 0,
      perPage: 0,
      Filter: this.$route.query.search_query,
      AdvancedFilterBroker: {
        name: null,
        phone: null,
        email: null,
        comment: null,
        enquiry_no: null,
        enquiry_source_id: null,
        visited: null,
        is_nri: null,
        building_id: [],
        next_call_date_from: null,
        next_call_date_upto: null,
        visit_date_from: null,
        visit_date_upto: null,
        created_at_from: null,
        created_at_upto: null,
        remove_recycled_enq: null,
      },
      Allvisited: [
        { value: null, text: "Visited" },
        { value: true, text: "yes" },
        { value: false, text: "No" },
      ],
      NriList: [
        { value: null, text: "Select NRI" },
        { value: true, text: "Yes" },
        { value: false, text: "No" },
      ],
    };
  },
  computed: {
    EnquiriesadvSParams() {
      return this.$store.getters.EnquiriesadvSParams;
    },
    EnquirystatusesList() {
      return this.$store.getters.EnquirystatusesMaster;
    },
    LeadSourcesList() {
      return this.$store.getters.EnquirySources;
    },
    brokersList() {
      return this.$store.getters.brokersMaster;
    },
    AssignedTo() {
      return this.$store.getters.AssignedToMaster;
    },
    ProjectsList() {
      return this.$store.getters.ProjectsMaster;
    },
    DeadReasonList() {
      return this.$store.getters.DeadReasonMaster;
    },
    totalPages() {
      if (this.total === 0 || this.perPage === 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.perPage);
      }
    },
    pageNo: {
      get() {
        let pageNo = this.$route.query.pageNo || 1;
        return parseInt(pageNo);
      },
      set() {
        true;
      },
    },
    pageStart() {
      if (this.total === 0) {
        return 0;
      }
      return Math.max(0, (this.pageNo - 1) * this.perPage + 1);
    },
    pageEnd() {
      if (this.total === 0) {
        return 0;
      }
      return Math.min(this.total, this.pageNo * this.perPage);
    },
  },
  mounted() {
    const meetingDetails = JSON.parse(sessionStorage.getItem("meetingDetails"));
    if (meetingDetails) {
      meetingDetails["comment"] = undefined;
      meetingDetails["created_at_upto"] = meetingDetails?.end_of_created_at;
      meetingDetails["created_at_from"] = meetingDetails.begning_of_created_at;
      meetingDetails["assigned_to"] = [meetingDetails.meeting_executive_id];
      const sendData = prepareEnquiriesSearchParams(meetingDetails);
      let newQ = { ...sendData, is_advanced_search: true };
      this.$router.replace({ query: newQ });
      this.FetchEnquiriesList();
    } else {
      this.FetchEnquiriesList();
    }
    sessionStorage.removeItem("meetingDetails");
    this.getSavedSearch();
  },
  watch: {
    $route(to, from) {
      this.FetchEnquiriesList();
    },
  },
  methods: {
    FetchEnquiriesList() {
      let queryP = {};
      if (this.$route.query.is_advanced_search) {
        let searchParams = this.$route.query;
        for (let key in searchParams) {
          queryP[key] = searchParams[key];
        }
        this.advSearchParams = queryP;
      }
      if (this.advSearchParams.length > 0) {
        paramsFromQuery(queryP, this.advSearchParams);
      } else {
        paramsFromQuery(queryP, this.$route.query);
      }
      this.$axios
        .get(`enquiries_builders`, {
          params: queryP,
          paramsSerializer: (params) =>
            qs.stringify(params, {
              arrayFormat: "brackets",
            }),
        })
        .then((res) => {
          this.GetEnquiriesList = res.data.enquiry;
          this.GetEnquiriesCount = res.data.count;
          this.backLogData = res.data.back_log_count;
          this.perPage = res.data.per_page;
          this.total = res.data.total_count;
        });
    },
    AdvancedFilter() {
      this.AdvancedFilterBroker["dead_reason_seq_ids"] =
        this.dead_reason_seq_ids.map((i) => i.seq);
      this.AdvancedFilterBroker["enquiry_statuses"] = this.enquiry_statuses.map(
        (i) => i.value
      );
      this.AdvancedFilterBroker["broker_ids"] = this.broker_ids.map(
        (i) => i.value
      );
      this.AdvancedFilterBroker["assigned_to"] = this.assigned_to.map(
        (i) => i.value
      );
      let queryp = {};
      let searchParams = prepareEnquiriesSearchParams(
        this.AdvancedFilterBroker
      );
      let newQ = { ...searchParams, is_advanced_search: true };
      this.$router.replace({ query: newQ });
    },
    saveSearch() {
      let queryP = {};
      let searchParams = prepareEnquiriesSearchParams(
        this.AdvancedFilterBroker
      );
      for (let key in searchParams) {
        queryP[key] = searchParams[key];
      }
      this.$axios
        .post("enquiries_builders/save_search", {
          save_search_params: queryP,
          search_name: this.search_name,
        })
        .then((res) => {
          this.search_name = null;
          this.saveSearchModal = false;
          this.getSavedSearch();
          swal({
            title: "Search Saved Successfully",
            icon: "success",
          });
        })
        .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
    },
    getSavedSearch() {
      this.$axios.get(`enquiries_builders/search_histories`).then((res) => {
        this.saved_search_list = [];
        res.data.search_history.forEach((item, index) => {
          this.saved_search_list.push({ value: item.id, text: item.name });
        });
        this.saved_search_list.unshift({
          value: null,
          text: "Select Saved Search",
        });
      });
    },
    resetAdvancedFilter() {
      this.AdvancedFilterBroker = {};
      this.dead_reason_seq_ids = [];
      this.assigned_to = [];
      this.broker_ids = [];
      this.enquiry_statuses = [];
      let rQ = this.$route.query;
      if (rQ.is_advanced_search) {
        this.$router.replace({
          query: {},
        });
      }
    },
    goToPage(pageNo) {
      let newQ = {
        ...this.$route.query,
        pageNo,
      };
      this.$router.replace({
        query: newQ,
      });
    },
    resetFilter() {
      let rQ = this.$route.query;
      this.Filter = "";
      if (rQ.search_query) {
        let { search_query, ...newQ } = rQ;
        this.$router.replace({
          query: newQ,
        });
      }
    },
    FilterData() {
      if (this.Filter) {
        let newQ = {
          ...this.$route.query,
          search_query: this.Filter,
        };
        this.$router.replace({
          query: newQ,
        });
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags {
  min-height: 50px;
  display: block;
  padding: 8px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #f6f6f6;
  font-size: 14px;
}
.today-call{
  width:100%;
  justify-content:space-between;
  padding: 0 15px;
}
.pagination {
  margin-top: 40px;
  padding-bottom: 100px;
}
.multiselect__tag {
  /* background: #41b883; */
  background: #233445;
}
.mb-fix {
  margin-bottom: 3px;
}
</style>